import {apiConstants, config, requestOptions, requestTypes, sendRequest} from "../../../Utilities/Api";

//************************************************** STANDARD API SERVER CALLS ****************************************
class serverShippingLocationApi {

    static addShippingLocation(shippingLocationModel: Record<string, unknown>) {
        return sendRequest(
            requestOptions(`${config.URL}shipping-locations`,
                requestTypes.POST,
                JSON.stringify(shippingLocationModel),
                apiConstants.successMessage.shippingLocation.ADD
            ),
        );
    }

    static removeShippingLocation(shippingLocationId: string) {

        return sendRequest(
            requestOptions(config.URL + `shipping-locations/${shippingLocationId}`,
                requestTypes.DELETE,
                null,
                apiConstants.successMessage.shippingLocation.DELETE
            ),
        );
    }

    static editShippingLocation(shippingLocationModel: Record<string, unknown>) {
        return sendRequest(
            requestOptions(`${config.URL}shipping-locations-edit`,
                requestTypes.PUT,
                JSON.stringify(shippingLocationModel),
                apiConstants.successMessage.shippingLocation.EDIT
            ),
        );
    }
}

export const shippingLocationApi = config.environment.MODE === config.modes.SERVER ? serverShippingLocationApi : serverShippingLocationApi;
